import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13.094 8.504a.7.7 0 0 1 .002.99l-3.1 3.111a.7.7 0 0 1-.992 0l-1.9-1.907a.7.7 0 1 1 .992-.988L9.5 11.12l2.604-2.614a.7.7 0 0 1 .99-.002"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
